import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import ServiceClosedLayout from '../layouts/serviceClosed';

class App extends Component {
  renderExternalRoutes = () => {
    return [
      <Route
        path="/cookies"
        key="cookies"
        component={() => {
          window.location.href = 'https://www.accurx.com/cookie-policy';
          return null;
        }}
      />,

      <Route
        path="/privacy"
        key="privacy"
        component={() => {
          window.location.href = 'https://www.accurx.com/privacy-policy';
          return null;
        }}
      />,

      <Route
        path="/terms"
        key="terms"
        component={() => {
          window.location.href = 'https://www.accurx.com/terms-and-conditions';
          return null;
        }}
      />,

      <Route
        path="/support"
        key="support"
        component={() => {
          window.location.href = 'https://support.accurx.com/';
          return null;
        }}
      />,
    ];
  };

  render = () => {
    return (
      <Switch>
        {this.renderExternalRoutes()}

        <Route path="/" component={ServiceClosedLayout} />
      </Switch>
    );
  };
}

export default App;
